const GET_MEETINGS_REQUEST = "GET_MEETINGS_REQUEST";
const GET_MANAGER_REPORT_REQUEST = "GET_MANAGER_REPORT_REQUEST";
const SCHEDULE_MEETING_REQUEST = "SCHEDULE_MEETING_REQUEST";
const RECORD_MEETING_TIME_REQUEST = "RECORD_MEETING_TIME_REQUEST";
const MANUAL_TRACK_MEETING_REQUEST = "MANUAL_TRACK_MEETING_REQUEST";
const MANAGER_REPORT_DRILLDOWN_REQUEST = "MANAGER_REPORT_DRILLDOWN_REQUEST";
const SET_USER_CALENDAR_OPT_OUT_REQUEST = "SET_USER_CALENDAR_OPT_OUT_REQUEST";
export const GET_MEETING_SLOTS_REQUEST = "GET_MEETING_SLOTS_REQUEST";

export const getMeetings = (query, callback, errorCallback) => ({
    type: GET_MEETINGS_REQUEST,
    payload: { query, callback, errorCallback },
});

export const getManagerReport = (query, callback, errorCallback) => ({
    type: GET_MANAGER_REPORT_REQUEST,
    payload: { query, callback, errorCallback },
});

export const scheduleMeeting = (payload, callback, errorCallback) => ({
    type: SCHEDULE_MEETING_REQUEST,
    payload: { payload, callback, errorCallback },
});

export const recordMeetingTime = (meetingId, payload, callback, errorCallback) => ({
    type: RECORD_MEETING_TIME_REQUEST,
    payload: { meetingId, payload, callback, errorCallback },
});

export const setMeetingManualTrack = (meetingId, tracked, callback, errorCallback) => ({
    type: MANUAL_TRACK_MEETING_REQUEST,
    payload: { meetingId, tracked, callback, errorCallback },
});

export const getManagerReportDrilldown = (query, callback, errorCallback) => ({
    type: MANAGER_REPORT_DRILLDOWN_REQUEST,
    payload: { query, callback, errorCallback },
});

export const setUserCalendarOptOut = (userId, optOut, callback) => ({
    type: SET_USER_CALENDAR_OPT_OUT_REQUEST,
    payload: { userId, optOut, callback },
});

export const getMeetingSlots = (payload, callback, errorCallback) => ({
    type: GET_MEETING_SLOTS_REQUEST,
    payload: { ...payload, callback, errorCallback },
});
